import { DesenrolaNorthEastImage } from './DesenrolaNorthEastImage'

import {
  DesenrolaNorthEastDescription,
  DesenrolaNorthEastTitle,
} from './DesenrolaNorthEast'

export const DesenrolaNorthEast = {
  Title: DesenrolaNorthEastTitle,
  Description: DesenrolaNorthEastDescription,
  Image: DesenrolaNorthEastImage,
}
